<template>
  <div
    v-html="enhancedValue"
    class="ai-input"
  ></div>
</template>

<script>
const { enhanceReportEmphasis } = require('@/utils/reportEmphasis')

export default {
  name: 'EyeAI',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    enhancedValue() {
      return enhanceReportEmphasis(this.value)
    }
  }
}
</script>

<style scoped>
.ai-input {
  height: 100%;
  width: 100%;
  font-size: 14px;
  line-height: 1.75;
  overflow-y: auto;
  color: #164e63;
  border: 1px solid #bae6fd;
  border-radius: 12px;
  padding: 14px 18px;
  box-sizing: border-box;
  text-align: left;
  background: transparent;
}

.ai-input ::v-deep h1,
.ai-input ::v-deep h2,
.ai-input ::v-deep h3 {
  color: #0f172a;
}

.ai-input ::v-deep h1 {
  margin: 0 0 12px;
  font-size: 22px;
  line-height: 1.35;
}

.ai-input ::v-deep h2 {
  margin: 20px 0 10px;
  padding-bottom: 6px;
  font-size: 18px;
  border-bottom: 1px solid #e0f2fe;
}

.ai-input ::v-deep h3 {
  margin: 14px 0 8px;
  font-size: 16px;
}

.ai-input ::v-deep p {
  margin: 7px 0;
}

.ai-input ::v-deep ul {
  margin: 8px 0 8px 20px;
  padding: 0;
}

.ai-input ::v-deep li {
  margin: 5px 0;
}

.ai-input ::v-deep li::marker {
  color: #0891b2;
}

.ai-input ::v-deep table {
  width: 100%;
  margin: 10px 0 4px;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
  line-height: 1.55;
}

.ai-input ::v-deep th,
.ai-input ::v-deep td {
  padding: 8px 10px;
  vertical-align: top;
  word-break: break-word;
  border: 1px solid #cbd5e1;
}

.ai-input ::v-deep th {
  color: #0f172a;
  font-weight: 700;
  text-align: left;
}

.ai-input ::v-deep .history-comparison-table th:nth-child(1),
.ai-input ::v-deep .history-comparison-table td:nth-child(1) {
  width: 18%;
}

.ai-input ::v-deep .history-comparison-table th:nth-child(4),
.ai-input ::v-deep .history-comparison-table td:nth-child(4) {
  width: 16%;
  font-weight: 700;
  color: #0e7490;
}

.ai-input ::v-deep .history-trend {
  display: inline-block;
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.ai-input ::v-deep .history-trend-up {
  color: #dc2626;
}

.ai-input ::v-deep .history-trend-down {
  color: #2563eb;
}

.ai-input ::v-deep .report-emphasis {
  position: relative;
  margin: 16px 0;
  padding: 14px 16px 14px 20px;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(15, 78, 99, 0.08);
  background: transparent;
}

.ai-input ::v-deep .report-emphasis::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 5px;
}

.ai-input ::v-deep .report-emphasis h3 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 17px;
  letter-spacing: 0.02em;
}

.ai-input ::v-deep .report-emphasis p:last-child,
.ai-input ::v-deep .report-emphasis ul:last-child {
  margin-bottom: 0;
}

.ai-input ::v-deep .report-emphasis-history {
  color: #164e63;
  border-color: #67e8f9;
}

.ai-input ::v-deep .report-emphasis-history::before {
  background: linear-gradient(180deg, #0891b2, #22d3ee);
}

.ai-input ::v-deep .report-emphasis-summary {
  color: #713f12;
  border-color: #fcd34d;
}

.ai-input ::v-deep .report-emphasis-summary::before {
  background: linear-gradient(180deg, #d97706, #fbbf24);
}

.ai-input ::v-deep .report-emphasis-followup {
  color: #14532d;
  border-color: #86efac;
}

.ai-input ::v-deep .report-emphasis-followup::before {
  background: linear-gradient(180deg, #059669, #22c55e);
}

.ai-input ::v-deep .report-emphasis-followup strong {
  display: inline-block;
  margin: 2px 4px 2px 0;
  padding: 1px 8px;
  color: #065f46;
  background: transparent;
  border: 1px solid rgba(5, 150, 105, 0.2);
  border-radius: 999px;
}

@media print {
  .ai-input {
    border-color: #d1d5db;
    background: transparent;
  }

  .ai-input ::v-deep .report-emphasis {
    box-shadow: none;
    break-inside: avoid;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

@media (max-width: 768px) {
  .ai-input ::v-deep .report-emphasis-history {
    overflow-x: auto;
  }

  .ai-input ::v-deep .history-comparison-table {
    min-width: 680px;
  }
}
</style>
